<template>
  <Modal
      :show.sync="isOpen"
      :on-close="onCloseModal"
    >
    <div class="mb_24">
        <h2 class="font_regular font_600 text_20">{{$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.HEADER')}}</h2>
    </div>
    <div>
        <InputCard
            :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.CONFIGURATION.MAIN')"
            :description="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.CONFIGURATION.SUB')"
            class="llm_input_field mt_20"
          >
          <div class="tool_card px_20 py_10">
            <InputField
              v-model="system_tool.name"
              :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.CONFIGURATION.NAME.LABEL')"
              type="text"
              :disabled="!!system_tool.id"
              :placeholder="$t('CAMPAIGN.LLM_CHATBOT.DELAY.PLACEHOLDER')"
            />
            <InputField
              v-model="system_tool.description"
              type="textarea"
              :rows="4"
              :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.CONFIGURATION.DESCRIPTION.LABEL')"
              :placeholder="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.CONFIGURATION.DESCRIPTION.PLACEHOLDER')"
            />
              <!-- :error="$v.llm.voice_settings.delay.$error ? $t('CAMPAIGN.LLM_CHATBOT.ADD.DELAY.ERROR') : ''"
              @blur="$v.llm.voice_settings.delay.$touch" -->


          </div>
          </InputCard>


        <InputCard
          v-if="system_tool.require_rule"
          :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.MAIN')"
          :description="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.SUB')"
          class="system_input_field mt_20"
        >
          <woot-button class="add_rule_btn" @click="addRule">
            Add rule
          </woot-button>

        <div
          v-for="(rule,index) in system_tool.rules"
          :key="index"
          class="tool_card px_20 py_10 mt_20"
        >
          <MultiselectDropdown
            :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.AGENT.LABEL')"
            :error="($v.system_tool.rules && $v.system_tool.rules.$each[index] && $v.system_tool.rules.$each[index].agent_id.$error) ? $t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.AGENT.ERROR') : ''"

          >
          <multiselect
            v-model="system_tool.rules[index].agent_id"
            :options="agent_list"
            class="small-12 font_normal"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.AGENT.PLACEHOLDER')"
            selected-label
            :select-label="''"
            :deselect-label="''"
          />
          </MultiselectDropdown>

          <InputField
            v-model="system_tool.rules[index].condition"
            type="textarea"
            :rows="4"
            :label="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.CONDITION.LABEL')"
            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.CONDITION.PLACEHOLDER')"
          />

          <div class="tool_del_btn">
            <woot-button @click="deleteRule(index)">
              {{$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.RULES.DELETE_BTN')}}
            </woot-button>
          </div>

        </div>

        </InputCard>

      <div class="mt_20">
        <woot-button
          :is-disabled="isSubmitting"
           :is-loading="isSubmitting"
          @click="handleSave"
        >
          {{$t('CAMPAIGN.LLM_CHATBOT.SYSTEM_TOOL_MODAL.SAVE_BTN')}}
        </woot-button>
      </div>

    </div>
  </Modal>
</template>

<script>

import Modal from "dashboard/components/Modal.vue";
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import InputSlot from 'components/ui/inputs/MultiselectDropdown.vue'; // use as input slot
import InputField from 'components/ui/inputs/InputField.vue';
import InputCard from "components/ui/inputs/InputCard.vue";
import SliderRangeInput from "components/ui/inputs/SliderRangeInput.vue";
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";
import { required, minLength, url, requiredIf } from 'vuelidate/lib/validators';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import ToggleField from 'components/ui/inputs/ToggleField.vue';
import {SYSTEM_TOOL_IDS} from "../ai.constant";

export default {
    components: {
      Modal,
      MultiselectDropdown,
      InputField,
      InputCard,
      SliderRangeInput,
      InputSlot,
      CheckboxInput,
      LoadingState,
      ToggleField
    },
    props: {
        isOpen: {
          type: Boolean,
          default: false,
        },
        system_tool: {
          type: Object,
          default: () => ({}),
          required: false,
        },
        agent_list: {
          type: Array,
          default: () => ([]),
        },
        isSubmitting: {
          type: Boolean,
          default: false,
        },
    },
    data(){
      return {
        SYSTEM_TOOL_IDS,
      }
    },
    validations() {
      return {
        system_tool: {
          rules: {
            $each: {
              agent_id: { required },
            },
          },
        },
      }
    },
    methods:{
      handleSave(){
        this.$v.system_tool.rules.$touch();
        if (this.$v.system_tool.rules.$invalid) {
          console.log(this.$v.system_tool);
          return;
        }
        // need to call create tool api
        this.$emit('onSubmit',this.system_tool)
      },
      onCloseModal(){
        this.$emit("onClose")
      },
      addRule(){
        this.system_tool.rules.push({
          agent_id: "",
          condition: "",
        })
      },
      deleteRule(index){
        this.system_tool.rules.splice(index, 1)
      },

    },
}
</script>


<style lang="scss" scoped>
.tool_card{
  background: #fff;
}
.system_input_field{
  position: relative;
  .add_rule_btn{
    position: absolute;
    top: 6px;
    right: 6px;
  }
}
.tool_del_btn{
  width: fit-content;
  margin-left: auto;
}
</style>